var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48556 6.63846C2.29544 6.63846 2.1381 6.58288 2.01352 6.47173C1.88895 6.36056 1.82666 6.22689 1.82666 6.07072C1.82666 5.91223 1.88895 5.77973 2.01352 5.67322C2.1381 5.56671 2.29544 5.51346 2.48556 5.51346H10.9346C11.1138 5.51346 11.2656 5.56757 11.39 5.67578C11.5144 5.78399 11.5767 5.91734 11.5767 6.07583C11.5767 6.232 11.5144 6.36481 11.39 6.47427C11.2656 6.58373 11.1138 6.63846 10.9346 6.63846H2.48556Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon-remove.7166d75e649c4cf28bf0ac616b6b7508.svg";
export { ForwardRef as ReactComponent };